import { DimeButton } from '../DimeButton.js';
import type { CardSortColumn, CardSortTable } from './card-sort-table.js';
import { cycleColumnSort } from './cycle-column-sort.js';
import { SortColumnIcon } from './SortColumnIcon.js';

function labelOf(column: CardSortColumn): string {
  const { header, meta } = column.columnDef;
  return meta?.label ?? (typeof header === 'string' ? header : column.id);
}

/** Card mode has no header row to click, so each sortable column becomes a toolbar button. */
export function DataTableCardSort({
  table,
  isLoading,
}: Readonly<{ table: CardSortTable; isLoading: boolean }>) {
  const columns = table.getVisibleLeafColumns().filter((column) => column.getCanSort());
  if (columns.length === 0) return null;

  return (
    <>
      {columns.map((column) => {
        const sorted = column.getIsSorted();
        const direction =
          sorted === 'desc' ? 'descending' : sorted === 'asc' ? 'ascending' : 'not sorted';
        const label = labelOf(column);
        return (
          <DimeButton
            key={column.id}
            type="button"
            variant="outline"
            size="sm"
            className="gap-1.5"
            disabled={isLoading}
            aria-label={`Sort by ${label}, ${direction}`}
            onClick={() => cycleColumnSort(column)}
          >
            <span>{label}</span>
            <SortColumnIcon sorted={sorted} />
          </DimeButton>
        );
      })}
    </>
  );
}
